export default ({
	EN: {
		heading: `We're sorry.`,
		subheading: 'Something is wrong here...',
		paragraph1: 'Our engineers are working hard to resolve this issue.',
		paragraph2: 'Please start over again. If the problem persists, please report the issue and we will contact you as soon as possible.',
		startOver: 'Start over'
	},
	ES: {
		heading: 'Lo sentimos',
		subheading: 'Algo está mal aquí...',
		paragraph1: 'Nuestros ingenieros están trabajando duro para resolver este problema.',
		paragraph2: 'Por favor empezar de nuevo. Si el problema persiste, por favor informe el problema y nos pondremos en contacto con usted lo antes posible.',
		startOver: 'Comenzar de nuevo'
	}
});
